import React, { PureComponent } from 'react';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import bindMethods from 'auto-bind';
import { connect } from 'react-redux';
import shortid from 'shortid';
import { withTranslation } from 'react-i18next';

import {
  FilterHeadline,
  FilterPaneContainer,
  ListContainer,
  ListItem,
} from './DownDistanceFilter';
import { createHyperCubeDefForField, getQlikApp } from '../../../utils/qlik';
import { FIELD_ZONE_KEY, getFilters } from '../../../state/selectors/filters';
import {
  setPossibleSelections,
  setSelections,
  toggleFieldZoneCollapse,
  clearPossibleSelections,
} from '../../../state/fieldZone';
import { FOOTBALL_FIELD_ZONE } from '../../../constants/fields';
import { getQlikAppId } from '../../../state/selectors/getQlikAppId';
import { sortFieldZone } from '../../../utils/sorting';

class FieldZoneFilter extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.hyperCubeDef = createHyperCubeDefForField(FOOTBALL_FIELD_ZONE);
  }

  componentDidMount() {
    const { qlikAppId } = this.props;

    if (qlikAppId) {
      this.getPossibleSelections();
    }
  }

  componentDidUpdate(prevProps) {
    const { qlikAppId, clearPossibleSelections } = this.props;

    if (!qlikAppId && prevProps.qlikAppId !== qlikAppId) {
      clearPossibleSelections();
    }

    if (qlikAppId && prevProps.qlikAppId !== qlikAppId) {
      this.getPossibleSelections();
    }
  }

  async getPossibleSelections() {
    const { qlikAppId, setPossibleSelections } = this.props;

    const app = await getQlikApp(qlikAppId);
    const results = await app.createCube(this.hyperCubeDef);

    const possibleSelections = results.layout.qHyperCube.qDataPages[0].qMatrix.map(x => x[0].qText);
    setPossibleSelections(possibleSelections);
  }

  handleListItemClick(item, event) {
    const { selections, setSelections } = this.props;
    const { name } = event.target.dataset;

    let updatedSelections = {};

    if (selections.hasOwnProperty(name)) {
      updatedSelections = { ...selections };
      delete updatedSelections[name];
    } else {
      updatedSelections = {
        ...selections,
        [name]: {
          min: item.operand1Min,
          max: item.operand1Max,
        },
      };
    }

    setSelections(updatedSelections);
  }

  sortFilters() {
    const { filters } = this.props;
    return sortFieldZone(filters);
  }

  render() {
    const {
      t, isCollapsed, selections, toggleFieldZoneCollapse,
    } = this.props;

    return (
      <FilterPaneContainer>
        <FilterHeadline onClick={toggleFieldZoneCollapse}>
          <h1>{t('Sidebar.FieldZone')}</h1>
          <FontAwesomeIcon size="lg" icon={isCollapsed ? faCaretUp : faCaretDown} />
        </FilterHeadline>

        <ListContainer id="Sidebar.FieldZone" isCollapsed={isCollapsed}>
          {this.sortFilters().map((d, k) => (
            <ListItem
              id={`Sidebar.FieldZone.option-${k}`}
              key={shortid.generate()}
              data-name={d.name}
              onClick={this.handleListItemClick.bind(null, d)}
              isSelected={selections.hasOwnProperty(d.name)}
            >
              {d.name}
            </ListItem>
          ))}
        </ListContainer>
      </FilterPaneContainer>
    );
  }
}

FieldZoneFilter.propTypes = {
  qlikAppId: PropTypes.string.isRequired, // supplied from Redux// supplied from Redux
  isCollapsed: PropTypes.bool.isRequired, // supplied from Redux
  // eslint-disable-next-line react/no-unused-prop-types
  possibleSelections: PropTypes.array.isRequired, // supplied from Redux
  clearPossibleSelections: PropTypes.func.isRequired, // supplied from Redux
  toggleFieldZoneCollapse: PropTypes.func.isRequired, // supplied from Redux
  setPossibleSelections: PropTypes.func.isRequired, // supplied from Redux
  setSelections: PropTypes.func.isRequired, // supplied from Redux
  t: PropTypes.func.isRequired, // supplied from withTranslation
  selections: PropTypes.object.isRequired, // supplied from Redux
  filters: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  qlikAppId: getQlikAppId(state),
  qlikToken: state.auth.qlikToken,
  isCollapsed: state.football.fieldZone.isCollapsed,
  possibleSelections: state.football.fieldZone.possibleSelections,
  selections: state.football.fieldZone.selections,
  values: state.football.fieldZone.values,
  filters: getFilters(FIELD_ZONE_KEY, state.filters),
});

const mapDispatchToProps = {
  toggleFieldZoneCollapse,
  setPossibleSelections,
  setSelections,
  clearPossibleSelections,
};

const TranslatedComponent = withTranslation()(FieldZoneFilter);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranslatedComponent);
